<div class="card-sso">
    <div class="card-sso__item" (click)="handleMicrosoftLogin()">
        <img src="assets/images/icon-microsoft.svg" alt="" />
        <label for="">Microsoft</label>
    </div>

    <div class="card-sso__item" (click)="handleGoogleLogin()">
        <img src="assets/images/icon-google.svg" alt="" />
        <label for="">Google</label>
    </div>
</div>